import { render, staticRenderFns } from "./item-foldout.vue?vue&type=template&id=94fbd8ac&scoped=true&"
import script from "./item-foldout.vue?vue&type=script&lang=ts&"
export * from "./item-foldout.vue?vue&type=script&lang=ts&"
import style0 from "./item-foldout.vue?vue&type=style&index=0&id=94fbd8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fbd8ac",
  null
  
)

export default component.exports